import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';

/**
 * Rutas de auth que se llaman sin sesión (no llevan Bearer).
 * No usar `url.includes('auth')`: también matchea /auth/mis-modulos y se pierde el token.
 */
export function isPublicAuthPath(url: string): boolean {
  const path = url.split('?')[0].toLowerCase();
  if (path.includes('/auth/mis-modulos')) {
    return false;
  }
  if (path.includes('/auth/login-site')) {
    return true;
  }
  if (/\/auth\/login$/i.test(path)) {
    return true;
  }
  if (path.includes('/auth/refresh')) {
    return true;
  }
  if (path.includes('/auth/logout')) {
    return true;
  }
  if (path.includes('/auth/version') || path.includes('version-app')) {
    return true;
  }
  return false;
}

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (isPublicAuthPath(req.url)) {
      return next.handle(req);
    }
    const token = localStorage.getItem('access_token');
    if (token) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      return next.handle(authReq);
    }
    return next.handle(req);
  }
}
